module.exports = __webpack_public_path__ + "static/media/wolffox1_preview.5fdb3450.jpg";